module.exports = __webpack_public_path__ + "static/palo_alto-c2547a586141d3d1a069669c3a933a0d.jpg";